const messages = {
    en: {
        role: {
            permissions: {
                AFIP_MENU: "Access to AFIP",
                AFIP_SHOW: "View AFIP",
                AFIP_CREATE: "Create billing to AFIP"
            }
        }
    },
    es: {
        role: {
            permissions: {
                AFIP_MENU: "Acceder a AFIP",
                AFIP_SHOW: "Ver AFIP",
                AFIP_CREATE: "Emitir factura AFIP"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                AFIP_MENU: "Access to AFIP",
                AFIP_SHOW: "View AFIP",
                AFIP_CREATE: "Create billing to AFIP"
            }
        }
    }
}

export default messages
